<template>
  <span class="tooltip__down">{{ $t(text) }}</span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admins.admin
    })
  },
  methods: {}
};
</script>
